import { configureStore }       from '@reduxjs/toolkit'

import rootReducer              from './RootReducer'
import { bomApi }               from 'src/services/rtk_api/bom/BomApi';
import { authApi }              from 'src/services/rtk_api/auth/authApi';
import { cartApi }              from 'src/services/rtk_api/order/CartApi';
import { checkoutApi }          from 'src/services/rtk_api/order/CheckoutApi';
import { productApi }           from 'src/services/rtk_api/product/ProductApi';
import { sessionApi }           from 'src/services/rtk_api/user/sessionApi';
import { userApi }              from 'src/services/rtk_api/user/UserApi';
import { contactApi }           from 'src/services/rtk_api/contact/contactApi';
import { teamsApi }             from 'src/services/rtk_api/team/TeamsApi';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat([
        bomApi.middleware,
        authApi.middleware,
        contactApi.middleware,
        cartApi.middleware,
        checkoutApi.middleware,
        productApi.middleware,
        sessionApi.middleware,
        userApi.middleware,
        teamsApi.middleware
      ])
})

export default store